/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";
import Button from "component/Button";
import Input from "component/Input";
import { useFormContext } from "react-hook-form";

type RegisterStep2FormData = {
  companylegalName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
};

function Step2({
  handleStep,
}: {
  handleStep: (type: "decrement" | "increment") => void;
}) {
  const theme = useTheme();
  const {
    register,
    trigger,
    formState: { errors, isValid },
  } = useFormContext<RegisterStep2FormData>();

  const handleNext = async () => {
    const isStepValid = await trigger();
    if (isStepValid) handleStep("increment");
  };

  return (
    <>
      <h1
        css={{
          fontSize: "24px",
          lineHeight: "28px",
          fontWeight: 600,
          marginTop: "40px",
          marginBottom: "0px",
        }}
      >
        Create your account
      </h1>

      <h4
        css={{
          fontSize: "14px",
          lineHeight: "18px",
          fontWeight: "normal",
          color: theme.darkGrey,
          marginTop: "16px",
          marginBottom: "40px",
        }}
      >
        Step 2 - Your invoicing information
      </h4>

      <Input
        label="Legal entity name"
        placeholder="Name"
        register={register}
        registerOption={{ required: `Company legal name can't be empty` }}
        name="companylegalName"
        error={errors.companylegalName && errors.companylegalName.message}
        css={{
          marginBottom: "16px",
        }}
      />

      <Input
        label="Address line 1 (street)"
        placeholder="Address Line 1"
        register={register}
        registerOption={{ required: `Address line 1 (street) can't be empty` }}
        name="addressLine1"
        error={errors.addressLine1 && errors.addressLine1.message}
        css={{
          marginBottom: "16px",
        }}
      />

      <Input
        label="Address line 2 (zip code and city)"
        placeholder="Address Line 2"
        register={register}
        registerOption={{
          required: `Address line 2 (zip code and city) number can't be empty`,
        }}
        name="addressLine2"
        error={errors.addressLine2 && errors.addressLine2.message}
        css={{
          marginBottom: "16px",
        }}
      />

      <Input
        label="Address line 3 (country)"
        placeholder="Address Line 3"
        register={register}
        registerOption={{
          required: `Address line 3 (country) can't be empty`,
        }}
        name="addressLine3"
        error={errors.addressLine3 && errors.addressLine3.message}
        css={{
          marginBottom: "16px",
        }}
      />

      <Button
        disabled={!isValid}
        onClick={handleNext}
        css={{
          marginTop: "48px",
          marginBottom: "16px",
        }}
      >
        Next
      </Button>

      <Button onClick={() => handleStep("decrement")} css={{}}>
        Back to Step 1
      </Button>
    </>
  );
}

export default Step2;
